import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { requestSpaceContents } from '../../app/actions/spaces/RequestSpaceContentsActions';
import { selectContentTotalLength } from '../../app/selectors/ContentSelectors';
import { AppState } from '../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../app/utils/ConnectUtils';
import { AllSchedulesSpace, AllSchedulesSpaceDispatchProps, AllSchedulesSpaceOwnProps, AllSchedulesSpaceStateProps } from './AllSchedulesSpace';

const mapStateToProps: MapStateToProps<AllSchedulesSpaceStateProps> = (state: AppState) => ({
  numberOfFetchedSchedules: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
});

const mapDispatchToProps: MapDispatchToProps<AllSchedulesSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
}, dispatch);

export const ConnectedAllSchedulesSpace: React.ComponentClass<AllSchedulesSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllSchedulesSpace);
